import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchHotel } from "../../../../../Redux/slice/features/dropdownHotelSlice";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../../env";
import { useNavigate } from "react-router-dom";
import { setAvailabilityData, clearAvailabilityData } from "../../../../../Redux/slice/features/availabilitySlice";
import { fetchUserDetails, rehydrateAuthState } from "../../../../../Redux/slice/features/authSlice";
import { use } from "react";

const RoomBooking = () => {
  const { isAuthenticated, user, loading } = useSelector((state) => state.auth);
  console.log("user inside room booking", user?.user?.PropertyID);
  const hotels = useSelector((state) => state.hotels.hoteldata);
  const [hotelList, setHotelList] = useState([]);
  const availabilityData = useSelector(
    (state) => state.availability.availableRooms
  );
  const [checkInDate, setCheckInDate] = useState("");
  const [checkOutDate, setCheckOutDate] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    // Reset all data on mount
    dispatch(clearAvailabilityData());
    setCheckInDate("");
    setCheckOutDate("");
    setSelectedHotel("");
    setHotelList([]);
    if (isAuthenticated && user?.user?.PropertyID!==null) {
      console.log('manager logged id')
      const fetchHotelByPropertyId = async () => {
        const response = await axios.get(
          `${REACT_APP_API_URL}api/dashboard/admin/hotel/${user?.user.PropertyID}`
        );
        
        setHotelList([response.data.data[0]]); 

      };
      fetchHotelByPropertyId()
    } else if (isAuthenticated && user?.user?.PropertyID=== null) {
      
      dispatch(fetchHotel());
      
    }
    
  }, []);

   useEffect(() => {
    if (user?.user?.PropertyID === null && hotels.length> 0) {
      setHotelList(hotels);
    }
  }, [hotels, user]);
  useEffect(() => {
    dispatch(rehydrateAuthState());
    dispatch(fetchUserDetails());
  }, [dispatch]);
  const [selectedHotel, setSelectedHotel] = useState("");
  const handleSelectChange = async (e) => {
    setSelectedHotel(e.target.value);
  };
  const today = new Date().toISOString().split("T")[0];
  const maxDate = new Date();
  maxDate.setDate(maxDate.getDate() + 90);
  const maxDateStr = maxDate.toISOString().split("T")[0];
  // min today +1 day
  const minTodayPlusOne = new Date(today).setDate(
    new Date(today).getDate() + 1
  );
  const minTodayPlusOneStr = new Date(minTodayPlusOne)
    .toISOString()
    .split("T")[0];

  const handleCheckAvailability = async (e) => {
    e.preventDefault();
    const check_in_date = checkInDate;
    const check_out_date = checkOutDate;
    localStorage.setItem("checkInDate", checkInDate);
    localStorage.setItem("checkOutDate", checkOutDate);

    try {
      const response = await axios.post(
        `${REACT_APP_API_URL}api/checkAvailibilty/${selectedHotel}`,
        {
          check_in_date,
          check_out_date,
        }
      );
      if (response.status === 200) {
        console.log("Availability data for tariff:", response.data);
        const availability = response.data.data;
        const roomTariff = response.data.roomConfigs;
        const mergedRooms = availability.map((room) => {
          const matchingTariff = roomTariff.find(
            (tariff) => tariff.RoomTypeId === room.RoomConfigID
          );
          return {
            ...room,
            ...(matchingTariff || {}),
          };
        });
        dispatch(
          setAvailabilityData({
            rooms: mergedRooms,
            check_in_date,
            check_out_date,
          })
        );
      }

      //   setShowModal(true);
    } catch (error) {
      console.error("Error checking availability:", error);
    }
  };

  const RoomBook = async (roomConfigId) => {
    const bookingKeySuffix =
      `:${selectedHotel}:${checkInDate}:${checkOutDate}`;

    Object.keys(localStorage).forEach((key) => {
      if (
        key.startsWith("pendingHotelBooking:") &&
        key.endsWith(bookingKeySuffix)
      ) {
        localStorage.removeItem(key);
      }
    });

    sessionStorage.removeItem(`redirectHotelBookingBack:${selectedHotel}`);
    sessionStorage.removeItem("currentBookingRef");
    sessionStorage.removeItem("currentOrderId");
    sessionStorage.removeItem("customerName");
    sessionStorage.removeItem("bookingAmount");

    navigate(`/hotels/${selectedHotel}`, {
      state: { newBooking: true },
    });
    console.log("RoomConfigId", roomConfigId);
  };

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <div className="row g-3">
        <div className="col-sm-12">
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <h3 className="fw-bold mb-0">Fill Out Booking Details</h3>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="card mb-3">
            <div className="card-header">
              <h6 className="card-title">Reservation Details</h6>
            </div>
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-6 col-lg-4 col-xl-4">
                  <div className="form-group">
                    <label className="form-label text-muted">Hotel Name</label>
                    <div className="input-group">
                      <span className="input-group-text">
                        <i className="bi bi-house"></i>
                      </span>
                      <select
                        className="form-select"
                        value={selectedHotel}
                        onChange={handleSelectChange}
                      >
                        <option value="" disabled>
                          -- Select Hotel --
                        </option>
                        {hotelList.map((hotel) => (
                          <option
                            key={hotel.PropertyID}
                            value={hotel.PropertyID}
                          >
                            {hotel.UnitName}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-4">
                  <div className="form-group">
                    <label className="form-label text-muted">
                      Check In <span className="text-danger">*</span>
                    </label>
                    <div className="input-group">
                      <span className="input-group-text">
                        <i className="bi bi-calendar-plus"></i>
                      </span>
                      <input
                        type="date"
                        className="form-control"
                        value={checkInDate}
                        min={today}
                        max={maxDateStr}
                        onChange={(e) => setCheckInDate(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-center">
                    <button
                      type="button"
                      className="btn btn-success mt-2"
                      onClick={handleCheckAvailability}
                    >
                      Check Availability
                    </button>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-4">
                  <div className="form-group">
                    <label className="form-label text-muted">
                      Check Out<span className="text-danger"> *</span>
                    </label>
                    <div className="input-group">
                      <span className="input-group-text">
                        <i className="bi bi-calendar-minus"></i>
                      </span>
                      <input
                        type="date"
                        name="datefilter"
                        className="form-control"
                        value={checkOutDate}
                        min={
                          checkInDate
                            ? new Date(
                                new Date(checkInDate).setDate(
                                  new Date(checkInDate).getDate() + 1
                                )
                              )
                                .toISOString()
                                .split("T")[0]
                            : minTodayPlusOneStr
                        }                      
                        onChange={(e) => setCheckOutDate(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="">
                  <div>
                    <h3>Room Availability</h3>
                    <div className="table-responsive">
                      <table
                        className="table table-bordered"
                        cellPadding="10"
                        cellSpacing="0"
                      >
                        <thead>
                          <tr>
                            <th>Room Type</th>
                            <th>Total Rooms</th>
                            <th>Available Rooms</th>
                            <th>Price Per Day</th>
                            <th>Extra Person Charge</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {availabilityData?.map((room) => (
                            <tr key={room.RoomConfigID}>
                              <td>{room.RoomConfig}</td>
                              <td>{room.TotalRooms}</td>
                              <td>{room.AvailableRooms}</td>
                              <td>{room.PricePerDay}</td>
                              <td>{room.ExtraPersonRate}</td>
                              {room.AvailableRooms > 0 ? (
                                <td>
                                  <button
                                    className="btn btn-primary"
                                    onClick={() => RoomBook(room.RoomConfigID)}
                                  >
                                    Book Room
                                  </button>
                                </td>
                              ) : (
                                <td>
                                  <button
                                    className="btn btn-secondary"
                                    disabled
                                  >
                                    Not Available
                                  </button>
                                </td>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div className="col-md-12 col-lg-12 col-xl-12"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoomBooking;
